import { SelectOption } from "../../../Widgets/LabeledSelect";

export interface CurrentCommunicationFormValues {
  primaryCommunicationModality: string;
  communicationProficiency: string;
  communicationFunctionLevel: string;
}

export const COMMUNICATION_MODALITY_OPTIONS: SelectOption[] = [
  { value: "NO_FUNCTIONAL_COMMUNICATION", label: "No functional communication" },
  { value: "IDIOSYNCRATIC", label: "Pre-symbolic / idiosyncratic (e.g., pulling, problem behavior)" },
  { value: "GESTURAL", label: "Gestural (e.g., pointing, nodding)" },
  { value: "VOCAL", label: "Vocal (non-symbolic sounds)" },
  { value: "VOCAL_VERBAL", label: "Vocal verbal (speech)" },
  { value: "SIGN_LANGUAGE", label: "Sign language" },
  { value: "AAC_LOW_TECH", label: "AAC – Low tech (PECS, boards)" },
  { value: "AAC_HIGH_TECH", label: "AAC – High tech (SGD/device)" },
];

export const COMMUNICATION_PROFICIENCY_OPTIONS: SelectOption[] = [
  { value: "NO_FUNCTIONAL_COMMUNICATION", label: "No independent functional communication" },
  { value: "PROMPTED_SINGLE_WORD_SOUNDS", label: "Communicates only with prompts" },
  { value: "INDEPENDENT_SINGLE_WORD_SOUNDS", label: "Emerging independent (single words/sounds)" },
  { value: "PROMPTED_MULTI_WORD_PHRASES", label: "Independent simple (1–3 words, limited range)" },
  { value: "INDEPENDENT_MULTI_WORD_PHRASES", label: "Independent functional (phrases, multiple contexts)" },
  { value: "INDEPENDENT_CONVERSATIONAL_SPEECH", label: "Conversational / generative" },
];

export const COMMUNICATION_FUNCTION_LEVEL_OPTIONS: SelectOption[] = [
  { value: "NO_FUNCTIONAL_COMMUNICATION", label: "No functional communication" },
  { value: "SIMPLE_MANDS_ONLY", label: "Requests only" },
  { value: "COMPLEX_MANDS", label: "Requests + basic regulation (e.g., protest, accept/reject)" },
  { value: "MULTIPLE_VERBAL_OPERANTS", label: "Multiple functions (e.g., requests, comments, social)" },
  { value: "GENERATIVE_SPEECH", label: "Broad / generative use across contexts" },
];

export const getLabelForValue = (options: SelectOption[], value: string): string =>
  options.find((o) => o.value === value)?.label ?? value;
